import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { alreadyHasAccount } from '@utils/child-status-utils';
import './only-one-account-allowed.scss';
import { useChildEligibilities } from '@react-query/hooks/query/use-child-eligibilities';
import { useTranslation } from '@translations';

export const OnlyOneAccountAllowed = () => {
    const { listOfChildren } = useTranslation();
    const { data: childEligibilities } = useChildEligibilities();
    const hasChildWithAccount = childEligibilities?.some((child) => alreadyHasAccount(child)) ?? false;

    if (!hasChildWithAccount) {
        return null;
    }

    return (
        <InfoMessage className="info-message" icon={IconTypes.INFO_24} text={listOfChildren.onlyOneAccountAllowed} />
    );
};
